import { post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const saveFile = async (payload) => {
  const builder = new UrlBuilder(`/admin/questions/save-file`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const deleteFile = async (payload) => {
  const builder = new UrlBuilder(`/admin/questions/delete-file`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const viewFile = async (payload) => {
  const builder = new UrlBuilder(`/admin/questions/view-file`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
